import QueryString from 'qs'
import { useEffect, useRef, useState } from 'react'
import { useLocation } from 'react-router-dom'
import { postAppReserve, postReserve } from '../api/orderHistory'
import { handlePostMessage } from '../js/postMessage'
import { getParsedLocalStorageItem } from '../js/script'
import { useCommonContext } from '../components/provider/CommonProvider'

export const imgURL = '/images'

const MypayPaid = () => {
  const formRef = useRef<HTMLFormElement>(null)
  const [myPayData, setMyPayData] = useState<any>(null)
  const [paylogo, setPaylogo] = useState<any>()
  const [option, setOption] = useState<any>()
  const [errormessage, setErrormessage] = useState<any>()
  const [mypayAccessToken, setMypayAccessToken] = useState<string>('')
  const { setIsLottie } = useCommonContext()
  const location = useLocation()

  // 유틸 함수 추후 분리가 필요할 수 있음
  const isEncoded = (str: string) => {
    try {
      return decodeURIComponent(str) !== str
    } catch {
      return false
    }
  }

  const safeJsonParse = (str: string) => {
    try {
      return JSON.parse(str)
    } catch (e) {
      console.error('JSON parse error:', e, str)
      return null
    }
  }

  const handleQueryApp = (app: any) => {
    window.localStorage.setItem('app', JSON.stringify(app))
  }

  const handleQueryAccessToken = (token: any, setMypayAccessToken: (v: string) => void) => {
    setMypayAccessToken(token as string)
  }

  const handleQueryProductData = (productdata: any, setOption: (v: any) => void) => {
    let decode = productdata as string
    if (isEncoded(decode)) {
      try {
        decode = decodeURIComponent(decode)
      } catch (e) {
        console.warn('decodeURIComponent error:', e, decode)
      }
    }

    const parsed = safeJsonParse(decode)
    if (parsed) setTimeout(() => setOption(parsed), 100)
  }

  const handleQueryPayLogo = (payLogo: any, setPaylogo: (v: any) => void) => {
    const parsed = safeJsonParse(payLogo as string)
    if (parsed) setPaylogo(parsed)
  }

  const handleSubmit = () => {
    const form = formRef.current
    if (form) {
      const url = form.action
      const formData = new FormData(form)

      const newForm = document.createElement('form')
      newForm.method = 'POST'
      newForm.action = url

      formData.forEach((value, key) => {
        const hiddenField = document.createElement('input')
        hiddenField.type = 'hidden'
        hiddenField.name = key
        hiddenField.value = value.toString()
        newForm.appendChild(hiddenField)
      })

      document.body.appendChild(newForm)
      newForm.submit()
      document.body.removeChild(newForm)
    }
  }

  const postAppReser = async (parse: any, accessToken: string) => {
    postAppReserve(parse, accessToken)
      .then((res) => {
        setMyPayData(res.data)
        setIsLottie(false)
      })
      .catch((err) => {
        console.log(err)
        setIsLottie(false)
        alert(err?.response?.data?.message)
        handlePostMessage({ actionType: 'goBack' })
        handlePostMessage({ actionType: 'onClose' })
        setErrormessage(err.response.data)
      })
  }

  const postReser = async (parse: any) => {
    postReserve(parse)
      .then((res) => {
        setMyPayData(res.data)
        setIsLottie(false)
      })
      .catch((err) => {
        console.log(err)
        setIsLottie(false)
        alert(err?.response?.data?.message)
        handlePostMessage({ actionType: 'goBack' })
        handlePostMessage({ actionType: 'onClose' })
        setErrormessage(err.response.data)
      })
  }

  useEffect(() => {
    setIsLottie(true)
  }, [])

  useEffect(() => {
    if (!location.search) return

    const query = QueryString.parse(location.search, { ignoreQueryPrefix: true })
    const localPaylogo = getParsedLocalStorageItem('myPayData')

    // 핸들러를 객체로 선언
    const handlers = {
      app: handleQueryApp,
      accesstoken: (value: any) => handleQueryAccessToken(value, setMypayAccessToken),
      productdata: (value: any) => handleQueryProductData(value, setOption),
      payLogo: (value: any) => handleQueryPayLogo(value, setPaylogo),
    }

    // 각 key에 대해 값이 있으면 실행
    Object.entries(handlers).forEach(([key, action]) => {
      if (query[key]) action(query[key])
    })

    if (!query.payLogo && localPaylogo) setPaylogo(localPaylogo)
  }, [location])

  useEffect(() => {
    const accessToken = getParsedLocalStorageItem('accessToken')
    if (option && accessToken) {
      postReser(option)
    } else if (option && mypayAccessToken) {
      postAppReser(option, mypayAccessToken)
    }
  }, [option, mypayAccessToken])

  useEffect(() => {
    setTimeout(() => {
      setIsLottie(false)
    }, 1000)
  }, [])

  useEffect(() => {
    if (errormessage) {
      postReserve(option)
        .then((res) => {
          setMyPayData(res.data)
        })
        .catch((err) => {
          console.log(err)
          setErrormessage(err?.response?.data?.message)
        })
    }
  }, [errormessage])

  useEffect(() => {
    if (myPayData !== null) handleSubmit()
  }, [myPayData])

  return (
    <>
      <div
        style={{
          display: 'flex',
          justifyContent: 'flex-end',
          minHeight: '60px',
          padding: '6px 14px',
        }}
      >
        <img
          style={{ width: '24px', height: '24px' }}
          src={`${imgURL}/icon_category_close.png`}
          alt=''
          onClick={() => {
            handlePostMessage({ actionType: 'goBack' })
            handlePostMessage({ actionType: 'onClose' })
          }}
        />
      </div>
      <div className='main_wrap'>
        <p>{JSON.stringify(errormessage)}</p>

        <form action={myPayData?.returnUrl} method='post' ref={formRef}>
          <input type='hidden' name='language' value={myPayData?.extraData.language} />
          <input type='hidden' name='mid' value={myPayData?.extraData.mid} />
          <input type='hidden' name='wpayUserKey' value={myPayData?.extraData.wpayUserKey} />
          <input type='hidden' name='wpayToken' value={myPayData?.extraData.wpayToken} />
          <input type='hidden' name='ci' value={myPayData?.extraData.wpayToken.ci} />
          <input type='hidden' name='payMethod' value={myPayData?.extraData.payMethod} />
          <input type='hidden' name='bankCardCode' value={myPayData?.extraData.bankCardCode} />
          <input type='hidden' name='oid' value={myPayData?.extraData.oid} />
          <input type='hidden' name='goodsName' value={myPayData?.extraData.goodsName} />
          <input type='hidden' name='goodsPrice' value={myPayData?.extraData.goodsPrice} />
          <input type='hidden' name='buyerName' value={myPayData?.extraData.buyerName} />
          <input type='hidden' name='buyerTel' value={myPayData?.extraData.buyerTel} />
          <input type='hidden' name='buyerEmail' value={myPayData?.extraData.buyerEmail} />
          <input type='hidden' name='cardQuota' value={myPayData?.extraData.cardQuota} />
          <input type='hidden' name='cardInterest' value={myPayData?.extraData.cardInterest} />
          <input type='hidden' name='couponCode' value={myPayData?.extraData.couponCode} />
          <input type='hidden' name='flagPin' value={myPayData?.extraData.flagPin} />
          <input type='hidden' name='flagCardPoint' value={myPayData?.extraData.flagCardPoint} />
          <input type='hidden' name='returnUrl' value={myPayData?.extraData.returnUrl} />
          <input type='hidden' name='signature' value={myPayData?.extraData.signature} />
          <input type='hidden' name='key' value={myPayData?.key} />
          <input type='hidden' name='resetCssUrl' value={`https://shop-api.e-ncp.com${paylogo?.customCssUrl}`} />
          <input type='hidden' name='customTitle' value={paylogo?.payName} />
        </form>
      </div>
    </>
  )
}

export default MypayPaid
